import {
  type AmendEmployerAgreementPoliciesCommandData,
  isDeleteEmployerAgreementPolicySelectionData,
} from '@festina/life-general-types/life'
import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useComponent, useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'

export const AmendEmployerAgreementPoliciesNestedCommand = (
  props: ActionButtonProps & { employerAgreementId: string },
) => {
  const translate = useTranslate()
  const AmendEmployerAgreementPoliciesForm = useComponent(
    'pages.employerAgreement.sidebar.AmendEmployerAgreementPoliciesForm',
  )

  const tenantId = useHook('routing.tenant.useTenantParam')()
  const actions = useHook(
    'mutators.life.useAmendEmployerAgreementCommandActions',
  )({
    tenantId,
    commandType: 'amendEmployerAgreementPolicies',
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })
  const submitWrapper = useMemo(() => {
    if (!submit) {
      return undefined
    }

    return {
      ...submit,
      onSubmit: (commandData: AmendEmployerAgreementPoliciesCommandData) => {
        const amendEmployerAgreementPolicySelectionDatas =
          commandData.amendEmployerAgreementPolicySelectionDatas?.map(
            (amendEmployerAgreementPolicySelectionData) =>
              isDeleteEmployerAgreementPolicySelectionData(
                amendEmployerAgreementPolicySelectionData,
              )
                ? {
                    ...amendEmployerAgreementPolicySelectionData,
                    changeEmployerAgreementPolicyData: undefined,
                  }
                : amendEmployerAgreementPolicySelectionData,
          )

        const commandDataWithAmendEmployerAgreementPolicySelectionDatas = {
          ...commandData,
          amendEmployerAgreementPolicySelectionDatas,
        }

        return submit.onSubmit(
          commandDataWithAmendEmployerAgreementPolicySelectionDatas,
        )
      },
    }
  }, [submit])

  return (
    <CommandModalButton
      actionId="life.AmendEmployerAgreementPoliciesCommandData"
      entityId={props.employerAgreementId}
      title={translate('amendEmployerAgreementPolicies.title')}
      commandDataForm={AmendEmployerAgreementPoliciesForm}
      {...props}
      submit={submitWrapper}
    />
  )
}
